const statusNames = {
  SITES: 'sites',
  SITE_RESET: 'site_reset',
  SITE_UNPUBLISH: 'site_unpublish',
  SITE_EXPORT: 'site_export',
};

export default statusNames;
